<section *ngIf="!modalPopup">
    <h1 *ngIf="organizations?.length > 1" style="font-family: Poppins; font-size: 14px; line-height: normal; overflow: hidden; color: white;
      background-color: #1481de;
      padding: 10px 18px !important;" class="mb-0 px-2">
        Switch Accounts</h1>
    <div style="max-height: calc(100vh - 200px); overflow-y: auto;">
      <menu [disabled]="isCurrentOrganization(org)" mat-menu-item (click)="switch(org.id)"
        *ngFor="let org of organizations" class="profile-menu" [ngClass]="{ 'active-menu': isCurrentOrganization(org)}">
        <div class="d-flex align-items-center pe-2">
            <div class="col-sm-2">
                <img class="menu-image" src="../../../../../assets/images/org_img.png">
            </div>
            <div class="col-sm-9 ms-2">
                <h2 style="font-family: Poppins; font-size: 12px; line-height: normal;" class="mb-0 white-space-normal">
                    {{org.name}}</h2>
                <p style="font-family: Poppins; font-size: 10px; line-height: 12px;"
                    class="mb-0 white-space-normal word-break-all">
                    {{org.email}}
                </p>
            </div>
            <div class="col-sm-1 d-flex align-items-center">
                <mat-icon class="mat-icon material-icons-outlined material-icons text-green font-18 mat-icon-18 mx-0"
                    *ngIf="isCurrentOrganization(org)" aria-hidden="true" data-mat-icon-type="font">check_circle
                </mat-icon>
            </div>
        </div>
    </menu>
    </div>

</section>

<section *ngIf="modalPopup">
    <mat-dialog-content class="mat-typography dialog-container">
        <button class="drawer-close-btn mat-elevation-z0" mat-dialog-close mat-mini-fab aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
        <!-- <button mat-button mat-dialog-close>X</button> -->
        <div class="agency-container">
            <div class="text-center">
                <img src="../../../../../assets/images/invoice-processor/invoice-automate-logo.svg"
                    style="height: 55px; margin: 40px 0 20px 0;" />
                <p style="font-family: 'Poppins'; font-size: 16px;">Key Management. Automated.
                </p>
                <h2
                    style="font-family: Poppins; font-size: 14px; font-weight: 600; line-height: normal; margin-top: 38px;">
                    Sign in as</h2>
            </div>
            <div class="d-flex align-items-center mx-auto"
              style="max-width: calc(100% - 100px); overflow-x: auto; justify-content: safe center;">
                <button [disabled]="isCurrentOrganization(org)"
                    [ngClass]="{ 'active-modal': isCurrentOrganization(org)}" class="agency-card"
                    (click)="switch(org.id)" *ngFor="let org of organizations">
                    <img class="profile-img" src="../../../../../assets/images/org_img.png">
                    <h2 style="font-family: Poppins; font-size: 12px; line-height: normal; margin-top: 10px; overflow: hidden;"
                        class="mb-0 px-2">
                        {{org.name}}</h2>
                    <p style="font-family: Poppins; font-size: 10px; line-height: normal; overflow: hidden;"
                        class="px-2 word-break-all">
                        {{org.email}}
                    </p>
                    <mat-icon class="mat-icon material-icons-outlined material-icons text-green font-18 mx-0"
                        *ngIf="isCurrentOrganization(org)" aria-hidden="true" data-mat-icon-type="font">check_circle
                    </mat-icon>
                </button>
            </div>
            <div class="common-spinner d-flex flex-row align-items-center justify-content-center rounded mt-4"
                *ngIf="switching">
                <mat-spinner strokeWidth="4" diameter="30"></mat-spinner>
                <h6 class="mt-0 ms-3">Loading...</h6>
            </div>
        </div>
    </mat-dialog-content>
</section>
